import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CategoryMake = () => {
  
  const devMode = process.env.NODE_ENV === 'development';

  const [slideoutFlag, setSlideoutFlag] = useState(false);
  const [categoryName, _setCategoryName] = useState('');
  const [categoryColor, setCategoryColor] = useState(0);
  const [headeruntop, setHeaderuntop] = useState(false);
  const setCategoryName = e => {_setCategoryName(e.target.value)};

  const navigate = useNavigate();

  useEffect(() => {
    document.getElementById('category-name-input').focus();
  }, []);

  const backFunc = () => {
    setSlideoutFlag(true);
    setTimeout(() => navigate(-1), 250);
  }

  const changeHeaderStyle = e => {
    if (e.target.scrollTop <= 0 && headeruntop) setHeaderuntop(false);
    else if (e.target.scrollTop > 0 && !headeruntop) setHeaderuntop(true);
  }

  const makeCategory = () => {
    if (categoryName.length > 0) {
      if (devMode) {
        fetch(`http://${window.location.hostname}:8080/mempad/cat/new`, {method: 'post', body: JSON.stringify({name: categoryName, color: categoryColor})}).then(() => {
          backFunc();
        });
      } else {
        const fd = new FormData();
        fd.append('name', categoryName);
        fd.append('color', categoryColor);
        fetch('/mempad/cat/new', {method: 'post', body: fd}).then(() => {
          backFunc();
        });
      }
    }
  }

  return (
    <div id="memo-layout" className={slideoutFlag ? "layout layout-over-slideout" : "layout layout-over"}>
      <header className={headeruntop ? 'header-untop' : ''}>
        <a className="header-left" onClick={backFunc}>＜戻る</a>
        <h3 className="header-title">カテゴリの追加</h3>
        <a className={categoryName.length === 0 ? 'header-right unactivelink' : 'header-right'} onClick={makeCategory}>＋作成</a>
      </header>
      <div className="top-scroller" onClick={e => e.target.parentElement.getElementsByTagName('main')[0].scrollTo({top:0, left:0, behavior: 'smooth'})} />
      <main onScroll={changeHeaderStyle}>
        <div className="content-box">
          <input id="category-name-input" className="line-input" type="text" value={categoryName} onChange={setCategoryName} placeholder="カテゴリ名" />
          <hr />
          {[...Array(13)].map((_, key) => 
            <span key={key}>
              <input hidden id={`colordata-${key}`} type="radio" name="colordata" value={key} checked={key === categoryColor} onChange={() => setCategoryColor(key)}/>
              <label className={`category-color bg-col${key}`} htmlFor={`colordata-${key}`} />
            </span>
          )}
        </div>
      </main>
    </div>
  );
}

export default CategoryMake;